import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')


export const state = {
  cached: {},
}

export const getters = {}

export const mutations = {
  EUROPAYLESS_ISSUE(state, euroPaylessIssue) {
    state.cached = euroPaylessIssue
  },
}

export const actions = {

  init({ state, dispatch }) {},

  fetchEuroPaylessIssue(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/euro_payless/issue/${query}`).then((response) => {
      const request = response.data
      context.commit('EUROPAYLESS_ISSUE', request)
      return request
    })
  },
  fetchReportManagementExcelPayless(context, payload) {
    // query = query || ''
    return axios.get(`${serverUrl}/euro_payless/issue/get_report/${payload.query}`, payload.type).then((response) => {
      return response
    })
  },

  fetchEuroPaylessIssueOptions(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/euro_payless/issues/options/${query}`).then((response) => {
      return response.data
    })
  },

  fetchEuroPaylessIssueDetail(context, url) {
    return axios.get(url).then((response) => {
      return response.data
    })
  },
}